import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { AppLocalization } from '../../shared/entities/app-localization';

// WARNING! Do NOT use/include this component directly. Use the SimpleUploadService. Refer to the documentation for more info.
@Component({
  selector: 'app-simple-upload',
  templateUrl: './simple-upload.component.html',
  styleUrls: ['./simple-upload.component.scss'],
  standalone: false
})

export class SimpleUploadComponent implements OnInit {
  appStrings: AppLocalization;
  isMobile: boolean;
  fileChangeEvent: (event: any) => Observable<any>;
  listFilesEvent: () => Observable<any>;
  downloadFileEvent: (fileId: string, fileName: string) => Observable<any>;
  deleteFileEvent: (fileId: string, index: number) => Observable<any>;
  fileList: any[] = [];
  displayedColumns = ['fileName', 'fileSize', 'deleteFile'];
  isLoading: boolean;
  isReadOnly = false;
  kb = 1024;
  loading = {
    filesLoading: false,
    delete: false,
  };

  constructor(private confirmationDialog: MatDialogRef<SimpleUploadComponent>,
    private appInfoService: AppInfoService,
    private notificationService: NotificationService,
    private deviceService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
    this.fileChangeEvent = this.data.fileChangeEvent;
    this.listFilesEvent = this.data.listFiles;
    this.downloadFileEvent = this.data.downloadFile;
    this.deleteFileEvent = this.data.deleteFile;
    this.isReadOnly = this.data.isReadOnly;
  }

  ngOnInit() {
    this.loading.filesLoading = true;
    this.loadFiles();
  }

  /**
   * Load all files
   */
  loadFiles() {
    this.listFilesEvent().subscribe(fileList => {
      this.fileList = fileList.slice();
      this.loading.filesLoading = false;
    });
  }

  /**
   * Closes the confirmation dialog
   */
  close() {
    this.confirmationDialog.close(true);
  }

  /**
   * File change event
   * @param event - The event
   */
  fileChange(event) {
    if (this.isReadOnly) {
      return;
    }

    this.loading.filesLoading = true;
    this.fileChangeEvent(event)
      .subscribe(
        () => {
          this.loadFiles();
          this.resetFileInput();
        },
        err => {
          if (err && typeof err === 'string') {
            // custom error
            this.notificationService.showNotification(err, NotificationType.Error, true);
          }
          this.loading.filesLoading = false;
          this.resetFileInput();
        }
      );
  }

  /**
   * Downloads file using file ID
   * @param fileId - The file ID
   * @param fileName - The file name
   */
  downloadFile(fileId: string, fileName: string) {
    this.downloadFileEvent(fileId, fileName);
  }

  /**
   * Deletes file using file ID
   * @param fileId - The file ID
   * @param index - attachment index
   */
  deleteFile(fileId: string, index: number) {
    this.loading.delete = true;
    this.deleteFileEvent(fileId, index)
      .subscribe(() => {
        this.loading.delete = false;
        this.loadFiles();
      });
  }

  private resetFileInput() {
    const fileInput = document.getElementById('uploadFileButton') as HTMLInputElement;
    fileInput.value = '';
  }

  /**
   * Handle drag over event
   * @param event - The drag event
   */
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Handle drag leave event
   * @param event - The drag event
   */
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Handle drop event
   * @param event - The drag event
   */
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.isReadOnly && event.dataTransfer?.files?.length) {
      this.fileChange(event.dataTransfer.files);
    }
  }
}
